import { useEffect } from 'react';

import { useParams } from '@tanstack/react-router';
import type { UseFormReturn } from 'react-hook-form';

import { useGetSupportTicketDetail } from '../shared/apis';
import type { SupportTicketDetailSchema } from '../shared/schemas/support-query-schema';

export function usePage({ ticketDetailsForm }: { ticketDetailsForm: UseFormReturn<SupportTicketDetailSchema> }) {
  const { id: companyId, ticket_id: ticketId } = useParams({ strict: false });

  const { data: ticket } = useGetSupportTicketDetail(ticketId || '');

  useEffect(() => {
    if (ticket) {
      ticketDetailsForm.reset(ticket);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticket]);

  return {
    ticket,
    companyId,
    ticketId,
  };
}
